import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // Check if sessionToken exists in localStorage
  const sessionToken = localStorage.getItem("sessionToken");

  // If no token, redirect to login page
  if (!sessionToken) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // If token exists, render the protected component
  return children;
};

export default ProtectedRoute;
